<div class="grid dz-grid padding-top-0 portfolio-table">
	<!-- BEGIN: Search Bar Input / Filter by Name / Create New Portfolio -->
	<div class="dz-row row search-group">
		<div class="search-input" [ngClass]="enableDeselectAll ? 'dz-col-14 col-14' : 'dz-col-18 col-18'">
			<input
				#searchText
				class="padding-left-5 search"
				placeholder="{{ searchPlaceholder }}"
				[formControl]="searchInput"
				(click)="setSearchInputFocused()"
				(keyup)="getPortfoliosByKeyFromKeyboardEvent($event)"
				type="text"
			/>
			<div class="search-icon">
				<icon type="search" *ngIf="!isSearchInputFocused"></icon>
				<icon
					type="times"
					*ngIf="isSearchInputFocused"
					class="input-times"
					(click)="clearSearchInputField()"
					custom-tracking
					track-event="portfolio-table:clear-search"
				></icon>
			</div>

			<div class="portfolio-types" *ngIf="enableFilterByPortfolioType">
				<a class="padding-left-5 portfolio-type-toggle" (click)="isPortfolioTypeMenuOpen = !isPortfolioTypeMenuOpen">
					<span dcrHTMLKey="TABLE_PORTFOLIO_SHOW_PORTFOLIO_TYPES">Show Portfolios</span>
					<icon type="chevron-up" class="icon" [ngClass]="{ collapsed: !isPortfolioTypeMenuOpen }"></icon>
				</a>

				<div class="menu" [ngClass]="{ open: isPortfolioTypeMenuOpen }">
					<dz-checkbox
						[value]="searchText.value"
						[checked]="portfolioGroupsToFilterBy.length === groupedPortfolios.length"
						(change)="toggleAllPortfolioTypes($event)"
						custom-tracking
						[track-event]="'portfolio-table:filter:checkbox:all types' + (portfolioGroupsToFilterBy.length === groupedPortfolios.length ? ':unchecked' : ':checked')"
					>
						<span class="portfolio-type" dcrHTMLKey="TABLE_PORTFOLIO_FILTER_ALL_TYPES">All Types</span>
					</dz-checkbox>
					<ng-container *ngFor="let group of groupedPortfolios">
						<dz-checkbox
							[value]="searchText.value"
							[checked]="portfolioGroupsToFilterBy.includes(group)"
							(change)="filterByPortfolioType($event, group)"
							custom-tracking
							[track-event]="'portfolio-table:filter:checkbox:' + group + (portfolioGroupsToFilterBy.includes(group) ? ':unchecked' : ':checked')"
						>
							<span class="portfolio-type">{{ PortfolioUtil.getSubTypeString(group) }} </span>
						</dz-checkbox>
					</ng-container>
				</div>
			</div>
		</div>
		<div *ngIf="showCreateNewPortfolioButton" class="dz-col-6 col-6 text-align-right create-new-portfolio-container">
			<dz-microaction track-event="portfolio table: create new portfolio" custom-tracking (menuItemClick)="openCreateNewPortfolio()" icon="plus">
				<span dcrHTMLKey="CREATE_NEW_PORTFOLIO" data-cy="create-new-portfolio-button-text">Create New Portfolio</span>
			</dz-microaction>
		</div>
		<div class="text-16-bold deselect-label" [ngClass]="{ 'dz-col-4 col-4': enableDeselectAll }" *ngIf="enableDeselectAll">
			<ng-container *ngTemplateOutlet="deselectAll"></ng-container>
		</div>
		<ng-content></ng-content>
	</div>

	<!-- END: Search Bar Input / Filter by Name / Create New Portfolio -->

	<!-- BEGIN: Group by type -->
	<div *ngIf="maxLimit > 1" class="selected-items">
		<p class="item-type" *ngFor="let group of groupedSelectedPortfolios">
			<ng-container *ngIf="groupSelectedPortfoliosByType"> {{ PortfolioUtil.getSubTypeString(group[0]['subType']) }} <br /> </ng-container>
			<span class="item" *ngFor="let portfolio of group">
				<span class="item-text"> {{ PortfolioUtil.getPortfolioName(portfolio) }}</span>
				<icon type="times" (click)="onPortfolioSelectionClick(portfolio)" custom-tracking track-event="portfolio-table:remove-portfolio"></icon>
			</span>
		</p>
		<div
			class="text-16-bold deselect-label pull-right"
			*ngIf="showDeselectAllWithPills && maxLimit > 1 && groupedSelectedPortfolios?.length"
			[ngClass]="{ 'dz-col-4 col-4': enableDeselectAll }"
		>
			<ng-container *ngTemplateOutlet="deselectAll"></ng-container>
		</div>
	</div>
	<ng-template #deselectAll>
		<dz-microaction
			[disabled]="!(maxLimit > 1 && groupedSelectedPortfolios?.length)"
			track-event="portfolio table: deselect all"
			custom-tracking
			(menuItemClick)="deselectAllPortfolios()"
			icon="times"
		>
			<span dcrHTMLKey="DESELECT_ALL_LABEL">Deselect All</span>
		</dz-microaction>
	</ng-template>
	<!-- END: Group by type -->

	<div [ngClass]="enablePagination ? 'paginated-table-container' : 'table-container'">
		<table class="display-table">
			<tr class="display-row">
				<th class="header cell text-14-bold" *ngFor="let header of headers">
					{{ header.getHeaderText() }}
					<icon
						type="sort"
						*ngIf="header.getSortingDirection() === SortDirection.UNSORTED"
						(click)="sortPortfoliosBy(header)"
						custom-tracking
						[track-event]="'portfolio-table:sort:' + header"
					></icon>
					<icon
						type="sort-asc"
						*ngIf="header.getSortingDirection() === SortDirection.ASC"
						(click)="sortPortfoliosBy(header)"
						custom-tracking
						[track-event]="'portfolio-table:sort:' + header"
					></icon>
					<icon
						type="sort-desc"
						*ngIf="header.getSortingDirection() === SortDirection.DESC"
						(click)="sortPortfoliosBy(header)"
						custom-tracking
						[track-event]="'portfolio-table:sort:' + header"
					></icon>
				</th>
			</tr>
			<tr class="empty-row" *ngIf="isPartiallyLoading">
				<td colspan="3">
					<span class="text-align-center text-16-bold partial-loading"
						>{{ partialLoadingMessage }}<span class="ellipsis-animation"><span>.</span><span>.</span><span>.</span></span>
					</span>
				</td>
			</tr>

			<ng-container *ngIf="!isFilteredPortfoliosEmpty()">
				<ng-container *ngIf="enablePagination; then pagination; else noPagination"> </ng-container>

				<ng-template #pagination>
					<tr
						class="display-row"
						*ngFor="let portfolio of portfolioPages[selectedPageIndex]; let i = index"
						[ngClass]="{ 'disabled-label': this.maxLimit === 0 || isRowDisabledByUniqueId.get(portfolio.uniqueId) }"
					>
						<ng-container *ngTemplateOutlet="portfolioRow; context: { portfolio: portfolio }"></ng-container>
					</tr>
				</ng-template>
				<ng-template #noPagination>
					<tr
						class="display-row"
						*ngFor="let portfolio of filteredPortfolios"
						[ngClass]="{ 'disabled-label': this.maxLimit === 0 || isRowDisabledByUniqueId.get(portfolio.uniqueId) }"
					>
						<ng-container *ngTemplateOutlet="portfolioRow; context: { portfolio: portfolio }"></ng-container>
					</tr>
				</ng-template>
			</ng-container>

			<ng-template #portfolioRow let-portfolio="portfolio">
				<td class="cell label-cell text-16">
					<div>
						<label class="ac-checkbox">
							<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
							<input
								type="checkbox"
								(change)="onPortfolioSelectionClick(portfolio)"
								[checked]="isPortfolioSelected(portfolio)"
								[disabled]="this.maxLimit === 0 || isRowDisabledByUniqueId.get(portfolio.uniqueId)"
								data-cy="portfolio-table-portfolio-checkbox"
								#portCheckBox
							/>
							<span class="portfolio-name" data-cy="portfolio-checkbox-cell">
								<span>{{ portfolio | portfolioName }}</span>
							</span>
						</label>
						<ng-container *ngIf="portCheckBox.checked">
							<icon
								type="exclamation-triangle"
								*ngIf="hasWarnings(portfolio) && !hasErrors(portfolio)"
								(click)="iconClicked([portfolio, hasErrors(portfolio)])"
								class="icon-warning"
								[matTooltip]="'Please review this portfolio.' | dcr : 'TABLE_PORTFOLIO_WARNING'"
								custom-tracking
								track-event="portfolio-table:warning-click"
							></icon>
							<icon
								type="exclamation-triangle"
								*ngIf="hasErrors(portfolio)"
								(click)="iconClicked([portfolio, hasErrors(portfolio)])"
								class="icon-error"
								[matTooltip]="
									'There are issues preventing this portfolio from being analysed in this tool - please review this portfolio.' | dcr : 'TABLE_PORTFOLIO_ERROR'
								"
								custom-tracking
								track-event="portfolio-table:error-click"
							></icon>
						</ng-container>
					</div>
				</td>
				<td class="cell" *ngIf="!hideLastModifiedDate">{{ PortfolioUtil.getPortfolioLastModifiedDate(portfolio) | date : dateFormat }}</td>
				<td class="cell">{{ PortfolioUtil.getPortfolioSubTypeString(portfolio) }}</td>
			</ng-template>

			<tr class="empty-row" *ngIf="isFilteredPortfoliosEmpty()">
				<td colspan="3"><span dcrHTMLKey="TABLE_PORTFOLIO_NO_PORTFOLIOS">There are no portfolios to display</span></td>
			</tr>
		</table>
	</div>
	<ng-container *ngIf="enablePagination">
		<div class="dz-row row padding-top-15 padding-bottom-15 pagination-container">
			<dz-pagination
				[length]="filteredPortfolios.length"
				[pageIndex]="selectedPageIndex + 1"
				[pageSize]="pageSize"
				[paginationType]="'BASIC'"
				(page)="handlePageEvent($event)"
			></dz-pagination>
		</div>
	</ng-container>
</div>
